/* --------------------------------------------------------------------------------------
   mainActionBar.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const mainActionBarComponent = {
  template: `
  <div id="action-bar" class="xrx-action-bar xrx-background navy">
    <button xw-button class="xrx-action-bar-button-left" glyph="user" ng-click="vm.logout()">{{vm.user}}</button>
    <div class="xrx-action-bar-label"><span translate>MAIN_TITLE</span></div>
    <button xw-button class="xrx-action-bar-button-right" glyph="gear" no-text ng-click="vm.openSettings()"></button>
  </div>
  `,
  controllerAs: 'vm',
  bindings: {
    user: '<',
    openSettings: '&',
    logout: '&'
  }
}



// WEBPACK FOOTER //
// ./src/app/components/mainActionBar.component.js